interface UsePathStatusProps {
  path: RoadmapPathVM;
  activePathId: number | null;
}

export const usePathStatus = ({ path, activePathId }: UsePathStatusProps) => {
  const isPathHidden: boolean =
    !!path.hidden ||
    !!(path.activatedAt && new Date() < new Date(path.activatedAt));
  const completedSteps = path.steps.filter(
    (s) => s.progress?.isCompleted,
  ).length;
  const totalSteps = path.steps.length;
  const pathProgress = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;
  const isPathCompleted = pathProgress === 100;
  const isPathInProgress = completedSteps > 0 && !isPathCompleted;
  const isPathActive = path.id === activePathId;

  return {
    isPathHidden,
    completedSteps,
    totalSteps,
    pathProgress,
    isPathCompleted,
    isPathInProgress,
    isPathActive,
  };
};
